import { PageBase } from "src/components/page-base";
import { YellowEmployeeDetails } from "../components/yellow-marked-employee";
//import { useRoles } from "src/context/roles-context";

export function YellowDetailsPage() {
    //const roles = useRoles();
    //const userPermited = roles.checkHasRole(add role to src/context/roles-context)
    const userPermited = true;

    return (
        <>
            <PageBase pageName="User Yellow Details" userPermitted={userPermited}>
                <>
                    <div className="flex-1 flex flex-col overflow-hidden p-8 gap-8">
                        <YellowEmployeeDetails />
                    </div>
                </>
            </PageBase>
        </>
    );
}
